import React from 'react';
import PrivacyPolicy from '../features/privacyPolicy';

const PrivacyPolicyPage = () => {
  return <PrivacyPolicy />;
};

export default PrivacyPolicyPage;
